var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8943 13.9991C11.2293 14.991 10.5243 15.9589 9.45067 15.9749C8.37706 15.9989 8.03254 15.343 6.81471 15.343C5.58887 15.343 5.2123 15.9589 4.19477 15.9989C3.1452 16.0389 2.35201 14.943 1.67899 13.9751C0.308936 11.9992 -0.740641 8.35944 0.669478 5.91161C1.36652 4.69569 2.6164 3.92774 3.97044 3.90374C4.99598 3.88774 5.97345 4.59969 6.6064 4.59969C7.23133 4.59969 8.41712 3.74375 9.65898 3.87174C10.1798 3.89574 11.638 4.07973 12.5754 5.45564C12.5033 5.50363 10.8368 6.47957 10.8528 8.50344C10.8768 10.9193 12.976 11.7272 13 11.7352C12.976 11.7912 12.6635 12.8871 11.8943 13.9991ZM7.31947 1.19992C7.90435 0.535964 8.8738 0.0319979 9.67501 0C9.77916 0.935938 9.4026 1.87988 8.84175 2.55183C8.28892 3.23179 7.37555 3.75975 6.4782 3.68776C6.35802 2.76782 6.8067 1.80788 7.31947 1.19992Z",
    fill: "#00868E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.fce7a6dd07ad2d506e2f4355078ca85a.svg";
export { ForwardRef as ReactComponent };